import {
  getAvailableBackUpBidAmount,
  getBestBid,
  getBuyerBidsCountered,
  getBuyerPremium,
  getPlaceBestBidDetails,
  submitPlaceBestBidResponse,
} from "@/api/bidDepositApiHold";
import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, ModalBody } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./PlaceBestBidModal.css";
import { trackApiCall, trackButtonClick, trackEvent } from "@/utils/analytics";
import { getPropertyType } from "@/utils/propCategory";

const PlaceBestBidModal = ({
  show,
  onHide,
  onSubmit,
  listingId,
  bidId,
  propertyCategory,
}) => {
  const [bidAmount, setBidAmount] = useState("");
  const [holdAsBackup, setHoldAsBackup] = useState(null);
  const [backupDuration, setBackupDuration] = useState("");
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [previousShowState, setPreviousShowState] = useState(false);
  const [buyerBidsUser, setBuyerBidsUser] = useState();
  const [nextBid, setNextBid] = useState();
  const [inputType, setInputType] = useState("number"); // To switch between number and text type
  const [displayBidAmount, setDisplayBidAmount] = useState(""); // For displaying formatted value
  const [buyersPremium, setBuyersPremium] = useState({
    buyerPremiumFormatted: "-",
    totalDueFormatted: "-",
    percentageFormatted: "-",
  });
  const [possibleAmount, setPossibleAmount] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const user = useSelector((state) => state?.user?.user);
  const bestBid = useSelector((state) => state?.pdp?.bidCenterData);

  const sellerId = useSelector(
    (state) => state?.pdp?.pdpInitData?.propertyDetails?.sellerId,
  );
  // console.log("ddd", sellerId);

  useEffect(() => {
    console.log("useEffect running with:", {
      show,
      previousShowState,
      hasListingId: listingId,
    });

    // Only run when the modal is opened (show changes from false to true)
    if (show && !previousShowState && listingId) {
      getBestBid(listingId).then((response) => {});
      getBuyerBidsCountered(listingId).then((response) => {
        const buyerBids = response?.data?.counteredBuyerBids[0];
        setBuyerBidsUser(buyerBids);
        if (response?.data?.status === "SUCCESS") {
          const payload = {
            bidId: buyerBids?.bidId,
            bidPlacedByAgent: buyerBids?.bidPlacedByAgent,
            listingId: listingId,
            sellerAccountId: user?.sellerId || sellerId,
          };
          getPlaceBestBidDetails(payload).then((response) => {
            const nextBidResponse = response?.data;
            setNextBid(nextBidResponse);
            if (response?.data?.statusMessage === "SUCCESS") {
              getAvailableBackUpBidAmount(listingId, 0).then((response) => {
                setPossibleAmount(response?.data?.data?.possibleBackUpAmount);
              });
            }
          });
        }
      });
      // Update the previous state for the next render
      setPreviousShowState(show);
    } else {
      console.log(
        "API calls NOT triggered because:",
        !show
          ? "modal is closed"
          : previousShowState
            ? "modal was already open"
            : !listingId
              ? "no listing ID"
              : "unknown reason",
      );
    }

    // Update the previous state for the next render
    setPreviousShowState(show);
  }, [show, listingId, previousShowState, user?.sellerId]);
  // Create a function to reset all form values

  // Add a useEffect to reset form values when the modal closes
  useEffect(() => {
    // When the modal is closed (show changes from true to false)
    if (!show && previousShowState) {
      // Reset all form values
      setBidAmount("");
      setDisplayBidAmount("");
      setValidationError("");
      setHoldAsBackup(null);
      setBackupDuration(""); // Or whatever your default value is
      setBuyersPremium({
        buyerPremiumFormatted: "-",
        totalDueFormatted: "-",
        percentageFormatted: "-",
      });
    }

    // Update the previous state for the next render
    setPreviousShowState(show);
  }, [show]);
  useEffect(() => {
    if (show) {
      setSubmitSuccess(false);
      setBidAmount("");
      setHoldAsBackup(false);
      setBackupDuration("");
    }
  }, [show]);

  const getFormatPrice = (amount) => {
    if (amount?.length === 0 || isNaN(amount)) {
      return "";
    }
    return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  };
  useEffect(() => {
    // You could add additional logic here if needed
  }, [submitSuccess]);
  // Add this function to handle validation
  // const validateBidAmount = async (value) => {
  //   // Clear previous errors
  //   setValidationError("");

  //   // Check if empty
  //   if (!value || value.trim() === "") {
  //     setValidationError("Please enter the bid amount");
  //     return;
  //   }

  //   // Convert to number and validate
  //   const numericValue = parseFloat(value);
  //   if (isNaN(numericValue)) {
  //     setValidationError("Please enter a valid number");
  //     return;
  //   }

  //   setIsValidating(true);
  //   try {
  //     // Call API to validate the bid amount
  //     const response = await getAvailableBackUpBidAmount(
  //       bestBid?.listingId,
  //       numericValue
  //     );
  //     const data = response.data;

  //     // Handle different error codes
  //     if (data.data?.errorCode === "BACKUP_BID_MUST_BE_MULTIPLE_OF_INCREMENT") {
  //       setValidationError(
  //         `Your bid must be in multiples of ${data.data.formattedIncrementMultplier}`
  //       );
  //     } else if (
  //       data.data?.errorCode === "BACKUP_BID_MUST_BE_LESSER_THAN_MAX"
  //     ) {
  //       setValidationError(
  //         `Your bid needs to be equal to or less than the maximum bid of ${data.data.formattedMaxBackUpBidLimit}`
  //       );
  //     } else if (data.data?.errorCode) {
  //       // Handle any other error codes
  //       setValidationError(
  //         data.data.errorCode.replace(/_/g, " ").toLowerCase()
  //       );
  //     }
  //   } catch (error) {
  //     setValidationError("An error occurred while validating your bid");
  //   } finally {
  //     setIsValidating(false);
  //   }
  // };
  // Handle focus - when user clicks on the input, show raw number without $ for editing

  const handleFocus = () => {
    setInputType("number");
    // If there's a value, remove the $ symbol for editing
    if (bidAmount) {
      setDisplayBidAmount(bidAmount);
    }
  };
  // Handle blur - format with $ when user leaves the field
  const handleBlur = async (e) => {
    const value = e.target.value;

    // Store the numeric value without $ for calculations
    if (value) {
      setBidAmount(value);

      // Format with $ for display
      setInputType("text");
      setDisplayBidAmount(`$${value}`);
    } else {
      // Reset premium values if input is empty
      setBuyersPremium({
        buyerPremiumFormatted: "-",
        totalDueFormatted: "-",
        percentageFormatted: "-",
      });
    }

    // Validate the input
    await validateBidAmount(value);
  };

  // Add this function to handle validation
  const validateBidAmount = async (value) => {
    // Clear previous errors
    setValidationError("");
    // Reset premium values
    setBuyersPremium({
      buyerPremiumFormatted: "-",
      totalDueFormatted: "-",
      percentageFormatted: "-",
    });
    // Check if empty
    if (!value || value.trim() === "") {
      setValidationError("Please enter the bid amount");
      return;
    }

    // Convert to number and validate
    const numericValue = parseFloat(value);
    if (isNaN(numericValue)) {
      setValidationError("Please enter a valid number");
      return;
    }
    // Check if the bid amount matches the nextBidResponse
    const nextBidValue = parseFloat(nextBid?.nextBidResponse);
    if (numericValue !== nextBidValue) {
      // If not equal, keep the premium fields as "-"
      setBuyersPremium({
        buyerPremiumFormatted: "-",
        totalDueFormatted: "-",
        percentageFormatted: "-",
      });
    }
    setIsValidating(true);
    try {
      // Call API to validate the bid amount
      const response = await getAvailableBackUpBidAmount(
        listingId,
        numericValue,
      );
      const data = response.data;

      // Handle different error codes
      if (
        data?.data?.errorCode === "BACKUP_BID_MUST_BE_MULTIPLE_OF_INCREMENT"
      ) {
        setValidationError(
          `Your bid must be in multiples of ${data?.data?.formattedIncrementMultplier}`,
        );
      } else if (
        data?.data?.errorCode === "BACKUP_BID_MUST_BE_LESSER_THAN_MAX"
      ) {
        setValidationError(
          `Your bid needs to be equal to or less than the maximum bid of ${data?.data?.formattedMaxBackUpBidLimit}`,
        );
      } else if (
        data?.data?.errorCode === "HIGHER_BACKUP_BID_AVAILABLE_FOR_USER"
      ) {
        setValidationError(
          `Your backup bid can't be lower than your current bid.`,
        );
      } else if (
        data?.data?.errorCode === "BACKUP_BID_MUST_BE_GREATER_THAN_MIN"
      ) {
        setValidationError(
          `Your bid needs to be at least $${getFormatPrice(
            data?.data?.possibleBackUpAmount,
          )}`,
        );
      } else if (data?.data?.errorCode) {
        // Handle any other error codes
        setValidationError(
          data.data.errorCode.replace(/_/g, " ").toLowerCase(),
        );
      } else {
        // If no error code, call getBuyersPremium API
        try {
          const premiumResponse = await getBuyerPremium(
            listingId,
            numericValue,
          );
          const premiumData = premiumResponse?.data;

          // Update the buyers premium and total due values
          setBuyersPremium({
            buyerPremiumFormatted: premiumData?.buyerPremiumFormatted || "-",
            totalDueFormatted: premiumData?.totalDueFormatted || "-",
            bidAmountFormatted: premiumData?.bidAmountFormatted || "-",
            percentageFormatted: premiumData?.percentageFormatted || "-",
          });
        } catch (premiumError) {
          // Reset premium values on error
          setBuyersPremium({
            buyerPremiumFormatted: "-",
            totalDueFormatted: "-",
            percentageFormatted: "-",
          });
        }
      }
    } catch (error) {
      setValidationError("An error occurred while validating your bid");
    } finally {
      setIsValidating(false);
    }
  };
  // Handle form submission
  const handleSubmit = async () => {
    // Validate form before submission
    if (!bidAmount) {
      setValidationError("Please enter a bid amount");
      return;
    }

    // if (holdAsBackup === null) {
    //   setValidationError("Please select whether to hold as backup bid");
    //   return;
    // }

    // if (holdAsBackup === true && !backupDuration) {
    //   setValidationError("Please select a backup duration");
    //   return;
    // }

    // Prepare request payload
    const payload = {
      bidId: buyerBidsUser?.bidId,
      listingId: listingId,
      sellerAccountId: user?.sellerId || sellerId, // Default or from data
      bidPlacedByAgent: buyerBidsUser?.bidPlacedByAgent, // Default value, adjust as needed
      buyerResponseAmount: parseFloat(bidAmount),
      backupBidAvailable: holdAsBackup === true ? true : false, // Explicitly convert to boolean
      backupBidExpiryDays: holdAsBackup === true ? backupDuration : null,
    };

    setIsSubmitting(true);
    setValidationError("");

    trackButtonClick({
      eventName: "submit_best_bid_click",
      eventCategory: "My Bids",
      eventSource: "on best bid click submit",
      eventLabel: `listingId:${payload.listingId}|bidAmount:${payload.buyerResponseAmount}|backupBidAvailable:${payload.backupBidAvailable}`,
    });

    try {
      // Call the API
      const response = await submitPlaceBestBidResponse(payload);

      // Determine if the response indicates success
      const responseData = response.data || response;
      const isSuccess = responseData.statusMessage === "SUCCESS";

      if (isSuccess) {
        setSubmitSuccess(true);
        setValidationError("");
        // onHide();
        trackEvent({
          name: "best_bid_placed",
          category: "My Bids",
          eventSource: "on best bid click submit success",
          property_type: getPropertyType(propertyCategory),
          seller_id: sellerId,
          bidId: responseData?.bidId,
          listingId: responseData?.listingId,
        });
      } else {
        setValidationError("Failed to submit bid");
        setSubmitSuccess(false);

        trackApiCall({
          eventName: "best_bid_placed_error",
          eventCategory: "My Bids",
          eventSource: "on best bid click submit failure",
          eventLabel: `listingId:${payload.listingId}|bidAmount:${payload.buyerResponseAmount}|backupBidAvailable:${payload.backupBidAvailable}`,
        });
      }
    } catch (error) {
      setValidationError(
        "An error occurred while submitting your bid. Please try again.",
      );
      setSubmitSuccess(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!holdAsBackup) {
      setBackupDuration("");
    }
  }, [holdAsBackup]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className="modal-title pb-modal-title-custom" closeButton>
        <Modal.Title className="modal-head pb-modal-head-custom">
          Place Best Bid
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-2">
          {!submitSuccess ? (
            <>
              <Form>
                <Form.Group className="mb-4">
                  <Row className="align-items-center">
                    <Col xs={4}>
                      <p className="mb-0 modal-detail-title">Your Bid Amount</p>
                    </Col>
                    <Col xs={4}>
                      <Form.Control
                        className="bid-amount-input"
                        type={inputType}
                        value={
                          inputType === "number" ? bidAmount : displayBidAmount
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            value === "" ||
                            value.replace(/[^\d]/g, "").length <= 9
                          ) {
                            setBidAmount(e.target.value);
                          }
                        }}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        disabled={isValidating}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}></Col>
                    <Col xs={6}>
                      <Form.Text className="d-block instructions">
                        Place a bid at or above the minimum amount of $
                        {possibleAmount.toLocaleString()}
                      </Form.Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={4}></Col>
                    <Col xs={6}>
                      {validationError && (
                        <Form.Text className="text-danger d-block error-msg">
                          {validationError}
                        </Form.Text>
                      )}
                    </Col>
                  </Row>
                </Form.Group>

                <hr />

                <Row className="mb-4 align-items-center">
                  <Col xs={4}>
                    <p className="mb-0 modal-detail-title">
                      {propertyCategory === "8"
                        ? "Transaction fee"
                        : `Buyer's Premium${
                            buyersPremium?.percentageFormatted &&
                            buyersPremium?.percentageFormatted !== "-"
                              ? ` (${buyersPremium.percentageFormatted})`
                              : ""
                          }`}
                    </p>
                  </Col>
                  <Col xs={4}>
                    <Form.Control
                      className="border-0 bg-white buyersPremiumTxt"
                      type="text"
                      value={buyersPremium?.buyerPremiumFormatted}
                      disabled
                    />
                  </Col>
                </Row>

                <hr />

                <Row className="mb-4 align-items-center">
                  <Col xs={4}>
                    <p className="mb-0 totalDue-title">Total Due</p>
                  </Col>
                  <Col xs={4}>
                    <Form.Control
                      className="border-0 bg-white totalDue-title"
                      type="text"
                      value={buyersPremium?.totalDueFormatted}
                      disabled
                    />
                  </Col>
                </Row>

                <hr />

                <Form.Group className="mb-4">
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    <Form.Check
                      type="checkbox"
                      id="backupCheckbox"
                      checked={holdAsBackup}
                      onChange={(e) => {
                        setHoldAsBackup(e.target.checked);
                        if (!e.target.checked) {
                          setBackupDuration("");
                        }
                      }}
                      className="mb-0"
                    />
                    <Form.Label
                      htmlFor="backupCheckbox"
                      className="mb-0 modal-detail-title"
                      style={{ cursor: "pointer" }}
                    >
                      If I'm not the winning bidder, hold my bid as a backup for
                    </Form.Label>
                    <Form.Select
                      className="w-auto"
                      value={backupDuration}
                      onChange={(e) =>
                        setBackupDuration(Number(e.target.value))
                      }
                      disabled={!holdAsBackup}
                    >
                      <option value="">10</option>
                      {nextBid?.backupBidExpiryDaysList?.map((duration, i) => (
                        <option key={i} value={duration}>
                          {duration} days
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </Form.Group>
              </Form>
            </>
          ) : (
            <div className="text-center py-4">
              <div className=" mt-4">
                <h4>Thank you for your bid.</h4>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {!submitSuccess ? (
          <>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitting || !bidAmount}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </Button>
            <Button
              variant="secondary"
              onClick={onHide}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </>
        ) : (
          <Button variant="primary" onClick={onHide}>
            Close
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default PlaceBestBidModal;
